module.exports = __webpack_public_path__ + "static/media/IMG_20191019_220010.d1867aad.webp";